import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pdf",
  "use": "pdf-usage",
  "viewBox": "0 0 98.3 115.9",
  "content": "<symbol viewBox=\"0 0 98.3 115.9\" id=\"pdf\"><path fill=\"#c22126\" d=\"M59.9 20.4H21.2v75.1h52V36.8H59.9z\" /><path fill=\"#ed2026\" d=\"M59.9 36.8h13.3L59.9 20.4z\" /><path fill=\"none\" d=\"M32.7 51.7H64V63H32.7z\" /><text transform=\"translate(32.667 62.914)\" font-size=\"15\" font-family=\"Roboto\" fill=\"#fff\">PDF</text></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pdf.svg
// module id = 4bXS
// module chunks = 1